<!-- main-footer -->
<footer class="main-footer">


    <div class="footer-bottom">
        <div class="auto-container">
            <div class="bottom-inner clearfix">
                <div class="copyright text-center">
                    <p>&copy;Copyright 2023  by ANMW. All Rights Reserved. | v{{appVersion}}</p>
                </div>
                <ul class="footer-nav clearfix pull-right">
                </ul>
            </div>
        </div>
    </div>
</footer>
<!-- main-footer end -->